import ChartAPI from "../../apps/common/chart-api";

// Yandex.Metrika counter
(function (m, e, t, r, i, k, a) {
  m[i] =
    m[i] ||
    function () {
      (m[i].a = m[i].a || []).push(arguments);
    };
  m[i].l = 1 * new Date();
  for (var j = 0; j < document.scripts.length; j++) {
    if (document.scripts[j].src === r) {
      return;
    }
  }
  (k = e.createElement(t)),
    (a = e.getElementsByTagName(t)[0]),
    (k.async = 1),
    (k.src = r),
    a.parentNode.insertBefore(k, a);
})(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
ym(91126829, "init", {
  clickmap: true,
  trackLinks: true,
  accurateTrackBounce: true,
  webvisor: true,
});

export default {
  state: {
    currentProject:
      JSON.parse(localStorage.getItem("currentProject")) ||
      JSON.parse(sessionStorage.getItem("currentProject")) ||
      null,
    projects: [],
    competitors: [],
    advertisers: [],
  },

  actions: {
    async fetchProjects({ commit, getters, dispatch, rootGetters }) {
      // Очищаем состояние при смене пользователя
      const currentUsername = rootGetters['user/username'];
      const storedUsername = localStorage.getItem('currentUsername');
      
      if (storedUsername && storedUsername !== currentUsername) {
        // Пользователь сменился - очищаем состояние
        commit("clearState");
        // Сохраняем нового пользователя
        localStorage.setItem('currentUsername', currentUsername);
      } else if (!storedUsername && currentUsername) {
        // Первый вход - сохраняем пользователя
        localStorage.setItem('currentUsername', currentUsername);
      }
      
      dispatch("filters/initSettings", null, { root: true });
      let studObj = new ChartAPI();
      let jsonOurResponse = await studObj.sendRequest("getProjects");
      
      // Проверяем, что получили валидный ответ
      if (jsonOurResponse && Array.isArray(jsonOurResponse) && jsonOurResponse.length) {
        jsonOurResponse.sort((currentValue, nextValue) =>
          currentValue.title > nextValue.title ? 1 : -1
        );
        // update list of projects
        commit("updateProjects", jsonOurResponse);
        // Проверяем, есть ли сохраненный проект в списке доступных
        let projectToSelect = null;
        
        if (getters.currentProject) {
          // Ищем сохраненный проект в списке доступных
          const savedProject = jsonOurResponse.find(p => p.id === getters.currentProject.id);
          if (savedProject) {
            projectToSelect = savedProject;
          } else {
            // Сохраненный проект не найден - выбираем первый доступный
            projectToSelect = jsonOurResponse[0];
          }
        } else {
          // Нет сохраненного проекта - выбираем первый доступный
          projectToSelect = jsonOurResponse[0];
        }
        
        // Обновляем текущий проект
        commit("updateCurrentProject", projectToSelect);
        
        // Получаем рекламодателей для выбранного проекта
        let jsonOurResponseAdvertiser = await studObj.getCompetitors(projectToSelect.id);
        if (jsonOurResponseAdvertiser && Array.isArray(jsonOurResponseAdvertiser) && jsonOurResponseAdvertiser.length) {
          localStorage.setItem(
            "firstProjectAdvertiser",
            JSON.stringify(jsonOurResponseAdvertiser[0])
          );
          sessionStorage.setItem(
            "firstProjectAdvertiser",
            JSON.stringify(jsonOurResponseAdvertiser[0])
          );
        }
        
        // Выбираем проект и загружаем связанные данные
        dispatch("selectCurrentProject", { currentProject: projectToSelect, resetFilters: false });
      }
    },
    async fetchCompetitors({ commit, rootGetters, dispatch }) {
      commit("updateCompetitors", []);
      commit("updateAdvertisers", []);
      commit("keywords_organic/updateFirstAdvertiser", null);
      let studObj = new ChartAPI();
      let jsonOurResponse = await studObj.getCompetitors(
        rootGetters["currentProjectId"]
      );

      const competitorsList = Array.isArray(jsonOurResponse) ? jsonOurResponse : [];
      if (competitorsList.length > 0) {
        commit("updateCompetitors", competitorsList);
        commit("updateAdvertisers", competitorsList);
        let firstAdvertiser = competitorsList[0];
        commit("keywords_organic/updateFirstAdvertiser", firstAdvertiser);
        dispatch("usp/selectUspCompetitor", { ...firstAdvertiser, uspId: 0 });
        localStorage.setItem(
          "firstProjectAdvertiser",
          JSON.stringify(firstAdvertiser)
        );
        sessionStorage.setItem(
          "firstProjectAdvertiser",
          JSON.stringify(firstAdvertiser)
        );
        commit("filters/updateCompetitorsFilter", firstAdvertiser);
        commit("filters/updateAdvertisersFilter", firstAdvertiser);
      } else {
        dispatch("usp/selectUspCompetitor", {
          ...rootGetters["currentProject"],
          uspId: 0,
        });
        commit("filters/updateCompetitorsFilter", null);
        commit("filters/updateAdvertisersFilter", null);
        localStorage.removeItem("firstProjectAdvertiser");
        sessionStorage.removeItem("firstProjectAdvertiser");
        commit("updateAdvertisers", []);
        commit("keywords_organic/updateFirstAdvertiser", null);
      }
    },
    async selectCurrentProject(
      { commit, dispatch, rootGetters },
      { currentProject, resetFilters = false }
    ) {
      commit("updateCurrentProject", currentProject);

      // При смене проекта сбрасываем кеш фильтров и данные, чтобы не оставались значения предыдущего проекта
      if (resetFilters) {
        // Сначала очищаем localStorage/sessionStorage, чтобы при загрузке опций не подтянулись старые значения
        localStorage.removeItem("keywordsTypes");
        sessionStorage.removeItem("keywordsTypes");
        localStorage.removeItem("keywords");
        sessionStorage.removeItem("keywords");
        localStorage.removeItem("geolocation");
        sessionStorage.removeItem("geolocation");
        // Сбрасываем состояние фильтров и списки опций (синхронно)
        commit("filters/updateKeywordsTypes", [], { root: true });
        commit("filters/updateKeywords", [], { root: true });
        commit("filters/updateGeoLocations", [], { root: true });
        commit("filters/updateOptionsKeywordsTypes", [], { root: true });
        commit("filters/updateOptionsKeywords", [], { root: true });
        commit("filters/updateOptionsGeolocations", [], { root: true });
        // Сбрасываем таблицу «Статистика по ключевым словам»
        dispatch("keywords/resetState");
        // Сбрасываем кэш УТП: выбранные рекламодатели и загруженные данные
        commit("usp/resetUspSelections", null, { root: true });
      } else {
        // При инициализации - сбрасываем только если они пустые (не загружены из localStorage)
        const currentKeywordsTypes = rootGetters["filters/keywordsTypes"];
        const currentKeywords = rootGetters["filters/keywords"];
        const currentGeoLocations = rootGetters["filters/geoLocations"];
        
        if (!currentKeywordsTypes || currentKeywordsTypes.length === 0) {
          dispatch("filters/selectKeywordsTypes", []);
        }
        if (!currentKeywords || currentKeywords.length === 0) {
          dispatch("filters/selectKeywords", []);
        }
        if (!currentGeoLocations || currentGeoLocations.length === 0) {
          dispatch("filters/selectGeoLocations", []);
        }
      }
      
      dispatch("filters/selectAdvertisersFilter", null);
      dispatch("keywords_organic/selectOnePeriod", null);
      dispatch("keywords_organic/selectOnePeriodValue", true);
      dispatch("keywords_organic/selectResetStatus", false);
      dispatch("keywords_organic/selectTopPersistenceFilterValue", null);
      dispatch("keywords_organic/selectTableThumblersHolding", false);
      dispatch("keywords_organic/selectComparingValueTable", true);
      if (
        rootGetters["filters/slice"] &&
        (rootGetters["filters/slice"]["value"] === "kwt" ||
          rootGetters["filters/slice"]["value"] === "ggr")
      ) {
        dispatch("filters/selectSlice", null);
      }
      dispatch("filters/fetchOptionsKeywordsTypes");
      dispatch("filters/fetchOptionsKeywords");
      dispatch("filters/fetchOptionsGeoLocations");
      dispatch("sov_dashboard/fetchSovReports");
      await dispatch("fetchCompetitors");
      dispatch("keywords/fetchKeywordsStats");
      dispatch("organic_sov_dashboard/fetchOrganicSovReports");
      dispatch("usp/initUspLists");
      dispatch("keywords_organic/fetchKeywordsOrganicStats", true);
      dispatch("wordstat/fetchWordstat");
    },
    async loadProjectLogo({ commit, rootGetters, dispatch }, currentProject) {
      commit("updateCurrentProject", currentProject);
      let studObj = new ChartAPI();
      return await studObj.sendRequest(
        "getLogo",
        rootGetters["currentProjectId"]
      );
    },
    
    // Принудительная очистка состояния (для выхода из системы)
    clearUserState({ commit }) {
      commit("clearState");
      localStorage.removeItem('currentUsername');
    },
  },
  mutations: {
    updateProjects(state, projects) {
      state.projects = projects;
    },
    updateCurrentProject(state, currentProject) {
      state.currentProject = currentProject;
    },
    updateCompetitors(state, competitors) {
      state.competitors = competitors;
    },
    updateAdvertisers(state, advertisers) {
      state.advertisers = advertisers;
    },
    // Очистка состояния при смене пользователя
    clearState(state) {
      state.currentProject = null;
      state.projects = [];
      state.competitors = [];
      state.advertisers = [];
      // Очищаем localStorage и sessionStorage
      localStorage.removeItem("currentProject");
      sessionStorage.removeItem("currentProject");
      localStorage.removeItem("firstProjectAdvertiser");
      sessionStorage.removeItem("firstProjectAdvertiser");
      // Очищаем фильтры wordstat
      localStorage.removeItem("wordstatPeriod");
      localStorage.removeItem("wordstatBrand");
      localStorage.removeItem("wordstatCategory");
      localStorage.removeItem("wordstatCombined");
    },
  },
  getters: {
    advertisersLink(state, getters, rootState, rootGetters) {
      return "?" + rootGetters["filters/dateRangeParam"];
    },
    currentProject(state) {
      return state.currentProject;
    },
    currentProjectId(state) {
      return state.currentProject ? state.currentProject.id : null;
    },
    projects(state) {
      return state.projects;
    },
    competitors(state) {
      return state.competitors;
    },
    advertisers(state) {
      return state.advertisers;
    },
  },
};
